import React from "react";

/**
 * Visual scent pyramid for AI Scent Direction.
 * Never called an official PERSONA formula — this is an AI interpretation only.
 */
export default function ScentPyramid({ top = [], heart = [], base = [], labels }) {
  const l = {
    top: labels?.top || "Top Notes",
    heart: labels?.heart || "Heart Notes",
    base: labels?.base || "Base Notes",
  };
  return (
    <div className="pfi-glass rounded-2xl p-6" data-testid="scent-pyramid">
      <div className="grid gap-3">
        <Row label={l.top} notes={top} testid="pyramid-top" width="60%" tint="rgba(230,198,135,0.20)" />
        <Row label={l.heart} notes={heart} testid="pyramid-heart" width="80%" tint="rgba(212,175,55,0.28)" />
        <Row label={l.base} notes={base} testid="pyramid-base" width="100%" tint="rgba(200,138,53,0.35)" />
      </div>
    </div>
  );
}

function Row({ label, notes, width, tint, testid }) {
  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <div
        className="relative rounded-xl border border-[#d4af37]/25 px-4 py-3 min-h-[64px] flex items-center justify-center"
        style={{ width, background: `linear-gradient(180deg, ${tint} 0%, transparent 100%)` }}
      >
        <div className="text-center">
          <div className="pfi-overline">{label}</div>
          <div className="mt-1.5 text-sm text-[#f8f8fc] flex flex-wrap gap-x-2 gap-y-1 justify-center">
            {(notes || []).length ? (
              (notes || []).map((n, i) => (
                <span key={i} className="whitespace-nowrap">
                  {n}
                  {i < notes.length - 1 ? <span className="text-[#6c6c7a]"> · </span> : null}
                </span>
              ))
            ) : (
              <span className="text-[#6c6c7a] text-xs">—</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
